import { render } from "./AdminCityComponent.vue?vue&type=template&id=8d6f3772"
import script from "./AdminCityComponent.vue?vue&type=script&lang=js"
export * from "./AdminCityComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__